import * as normalize from 'utils/normalize';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getPatientName from 'utils/print/getPatientName';
import getInsuranceID from 'utils/print/getInsuranceID';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineTotalCost from 'utils/print/getOrderLineTotalCost';
import getSignature from 'utils/print/getSignature';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketABN = {
  ID: 28,
  Name: 'Advance Beneficiary Notice',
  Type: 'Delivery Ticket',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-ABN/1.js',
      fields: [
        {
          name: 'Notifier',
          type: 'text',
          getValue: props => getFacilityName(props) || getBusinessName(props),
          x: 41,
          y: 10,
          width: 70,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 53,
          y: 17,
          width: 58,
        },
        {
          name: 'Identification Number',
          type: 'text',
          getValue: getInsuranceID,
          x: 162,
          y: 17,
          width: 42,
        },
        {
          name: 'D 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 85,
          y: 42,
          width: 33,
        },
        ...[0, 1, 2, 3, 4, 5, 6].reduce((accumulator, currentValue) => {
          const y = 68.5 + (currentValue * 4.8);
          return [
            ...accumulator,
            {
              name: `HCPCS Code ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 19,
              y,
              width: 72,
            },
            {
              name: `Reason Medicare May Not Pay ${currentValue}`,
              type: 'text',
              x: 94,
              y,
              width: 73,
            },
            {
              name: `Estimated Cost ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCost({ ...props, index: currentValue }),
              x: 169,
              y,
              width: 31,
            },
          ];
        }, []),
        {
          name: 'D 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 158,
          y: 53,
          width: 28,
        },
        {
          name: 'Option',
          type: 'radio',
          options: [
            {
              x: 19,
              y: 143,
              width: 4,
              height: 4,
              value: 'Option 1',
            },
            {
              x: 19,
              y: 168,
              width: 4,
              height: 4,
              value: 'Option 2',
            },
            {
              x: 19,
              y: 178,
              width: 4,
              height: 4,
              value: 'Option 3',
            },
          ],
        },
        {
          name: 'D 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 138,
          y: 119,
          width: 28,
        },
        {
          name: 'D 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 72,
          y: 143,
          width: 28,
        },
        {
          name: 'D 5',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 72,
          y: 167.5,
          width: 28,
        },
        {
          name: 'D 6',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 82,
          y: 177.5,
          width: 28,
        },
        {
          name: 'Additional Information',
          type: 'text',
          x: 14,
          y: 193,
          width: 186,
          height: 13,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 50,
          y: 219,
          width: 70,
          height: 12,
        },
        {
          name: 'Signature Date',
          type: 'text',
          getValue: getSignatureDate,
          x: 127,
          y: 224.5,
          width: 38,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketABN;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-ABN.js